import { render } from "./FiltersWrapper.vue?vue&type=template&id=3eca1bb0"
import script from "./FiltersWrapper.vue?vue&type=script&lang=js"
export * from "./FiltersWrapper.vue?vue&type=script&lang=js"

import "./FiltersWrapper.vue?vue&type=style&index=0&id=3eca1bb0&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__